import { render } from "./Goals.vue?vue&type=template&id=5af56cae"
import script from "./Goals.vue?vue&type=script&lang=js"
export * from "./Goals.vue?vue&type=script&lang=js"

import "./Goals.vue?vue&type=style&index=0&id=5af56cae&lang=css"
script.render = render

export default script